export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    slug: 'illustration',
    name: '萝莉插画',
    description: '汇聚国内外优秀画师的萝莉主题插画作品，涵盖日系、国风、韩系等多种风格，每一幅都是用心之作。',
    icon: 'ri-brush-line',
    imageSeq: 'loli-illustration-01',
  },
  {
    slug: 'character',
    name: '角色设定',
    description: '原创萝莉角色设定集，包含人物背景、性格特点、服装设计等详细资料，激发你的创作灵感。',
    icon: 'ri-user-heart-line',
    imageSeq: 'loli-character-01',
  },
  {
    slug: 'fanart',
    name: '同人创作',
    description: '基于热门ACG作品的二次创作专区，萝莉角色的同人插画、漫画、小说等精彩内容应有尽有。',
    icon: 'ri-pencil-ruler-2-line',
    imageSeq: 'loli-fanart-01',
  },
  {
    slug: 'anime',
    name: 'ACG动漫',
    description: '最新动漫资讯、萝莉角色盘点、番剧推荐与深度评测，紧跟二次元文化潮流前沿。',
    icon: 'ri-tv-line',
    imageSeq: 'loli-anime-01',
  },
  {
    slug: 'community',
    name: '社区讨论',
    description: '萝莉次元社区的交流天地，画师心得分享、创作技法讨论、活动公告与成员互动。',
    icon: 'ri-chat-smile-2-line',
    imageSeq: 'loli-community-01',
  },
];